module.exports = __webpack_public_path__ + "img/arrecredihome2v_3.19629ce9.webp";